import styled from 'styled-components';
import { combineValues, globalTheme } from '@cld/component-theme';
import { Icon, iconMixin, iconTheme } from '@cld/icon';
import Progress from '@cld/progress';

export const StyledToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${combineValues(iconTheme.xs, globalTheme.spacing.xs, (size, spacing) => `calc(${size} + ${spacing} * 2)`)};
  flex-shrink: 0;

  ${Icon},${Progress.Circular} {
    ${(props) => iconMixin({ ...props, size: 'xs' })}
    margin: 0;
  }
`;

export default StyledToggleWrapper;
